import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row } from '../../../lib/utils';
import { Body2Bold } from '../../../lib/font';
import { colors } from '../../../lib/colors';

interface PaymentHeaderProps {
    title: string;
    onBack?: () => void;
}

const PaymentHeader: React.FC<PaymentHeaderProps> = ({ title, onBack }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    return (
        <Row
            style={{
                width: '100%',
                height: 56,
                alignItems: 'center',
                padding: '0 16px',
                backgroundColor: '#FFFFFF',
                borderBottom: '1px solid #F0F0F0',
                position: 'sticky',
                top: 0,
                zIndex: 10,
            }}
        >
            <button
                onClick={handleBack}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 8,
                    marginLeft: -8,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M15 19l-7-7 7-7" stroke={colors.LAVEL_4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <Body2Bold style={{ color: colors.LAVEL_4, flex: 1, textAlign: 'center', marginRight: 24 }}>
                {title}
            </Body2Bold>
        </Row>
    );
};

export default PaymentHeader;
